<script>
  import { CircleCheck, CircleAlert, TriangleAlert, Info, X } from 'lucide-svelte';

  import { notifications } from './notification';

  const styles = {
    success: {
      icon: CircleCheck,
      iconColor: 'text-emerald-600',
      bg: 'bg-emerald-50'
    },

    error: {
      icon: CircleAlert,
      iconColor: 'text-red-600',
      bg: 'bg-red-50'
    },

    warning: {
      icon: TriangleAlert,
      iconColor: 'text-amber-600',
      bg: 'bg-amber-50'
    },

    info: {
      icon: Info,
      iconColor: 'text-blue-600',
      bg: 'bg-blue-50'
    }
  };
</script>

<div
  class="fixed top-4 right-4
  z-[9999]
  flex flex-col gap-2">
  {#each $notifications as item (item.id)}
    <div
      class="w-[340px]
      min-h-[46px]
      border border-gray-300
      rounded-lg
      bg-white
      shadow-md
      animate-[slideIn_.15s_ease-out]">
      <div class="flex items-center gap-3 px-3 py-2.5">
        <div
          class={`w-7 h-7 rounded-full
          flex items-center justify-center
          ${styles[item.type].bg}`}>
          <svelte:component this={styles[item.type].icon} size={14} class={styles[item.type].iconColor} />
        </div>

        <div
          class="flex-1
          text-[13px]
          text-slate-700
          leading-5">
          {item.message}
        </div>
      </div>
    </div>
  {/each}
</div>

<style>
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateX(12px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
</style>
